import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

export const language_PT_BR = {
  ...MRT_Localization_PT_BR,
  actions: 'Ações',
  and: 'e',
  cancel: 'Cancelar',
  changeFilterMode: 'Alterar o modo de filtro',
  changeSearchMode: 'Alterar o modo de pesquisa',
  clearFilter: 'Limpar filtros',
  clearSearch: 'Limpar pesquisa',
  clearSort: 'Limpar classificações',
  clickToCopy: 'Clique para copiar',
  rowsPerPage: 'Itens por página',
  sortByColumnAsc: 'Ordenar por coluna (ascendente)',
  sortedByColumnAsc: 'Ordenado por coluna (ascendente)',
  sortByColumnDesc: 'Ordenar por coluna (descendente)',
  sortedByColumnDesc: 'Ordenado por coluna (descendente)',
  toggleSelectAll: 'selecionar todos',
  toggleSelectRow: 'Selecionar esta linha',
  noRecordsToDisplay: 'Não há registros a serem exibidos',
  selectedCountOfRowCountRowsSelected:
    '{selectedCount} de {rowCount} linha(s) selecionada(s)',
};
